export default "__VITE_ASSET__CrQrZN6Q__"